export const fakeAnalytics = {
  track: () => Promise.resolve(),
};
